import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NotificationTemplateDTO, NotificationTemplateGenSvc } from 'src/app/services_autogenerated/generated_services';

@Component({
    selector: 'app-notification-templates',
    templateUrl: './notification-templates.component.html',
    styleUrls: ['./notification-templates.component.css'],
    standalone: false
})
export class NotificationTemplatesComponent implements OnInit {

  cols: any[];
  templates: NotificationTemplateDTO[] = [];

  constructor(private notificationTemplateService: NotificationTemplateGenSvc,
    private router: Router
  ) { }

  ngOnInit() {
    this.cols = [
      { field: 'name', header: 'Template Name' },
      { field: 'subject', header: 'Email Subject'},
      { field: 'tile', header: 'Notification Title' },
      { header: '', width: '7%' }
    ];

    this.notificationTemplateService.get().subscribe(res => this.templates = res);
  }

  editTemplate(template: NotificationTemplateDTO) {
    this.router.navigateByUrl('/notificationTemplate/' + template.id);
  }
}
